export function isSpainCountry(value: string | undefined): boolean {
  return ['es', 'espana', 'españa', 'spain'].includes(
    (value ?? '').trim().toLowerCase(),
  )
}

export function normalizeShippingCountry(value: string | undefined): string {
  const trimmedValue = (value ?? '').trim()
  return isSpainCountry(trimmedValue) ? 'España' : trimmedValue
}
